const options = JSON.parse('{"path":"/version.json","check_interval":300000,"version":"2025-04-24T13:35:44+00:00"}')

export default ({ app }) => {
  let last_check_time = new Date()
  app.router.afterEach(async () => {
    const last_check_interval = new Date() - last_check_time
    if (last_check_interval >= options.check_interval) {
      last_check_time = new Date()
      const version = await get_remote_version()
      if (version !== options.version) {
        options.version = version
        window.$nuxt.$emit('nuxt-detect-update', version)
      }
    }
  })
}

async function get_remote_version() {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', options.path)
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          const { version } = JSON.parse(xhr.responseText)
          if (version) {
            resolve(version)
          } else {
            reject('Malformed version response.')
          }
        } catch (err) {
          reject(err)
        }
      } else {
        reject('Request failed.')
      }
    }
    xhr.send()
  })
}
